import { Select, FormControl, FormHelperText, FormLabel, MenuItem } from '@mui/material';
import { FC, FocusEventHandler } from 'react';
import { BilledToLabelToType, BilledToType, BilledToTypeToLabel } from '../../dtos/enums/BilledToType';


export interface IMaterialBilledToSelectProps {
    selectedBilledTo: BilledToType;
    handleSelectedBilledToChange: (selectedBilledTo: BilledToType) => void;
    required?: boolean;
    errorMessage?: string;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    disabled?: boolean;
    label?: string;

}

export const MaterialBilledToSelect: FC<IMaterialBilledToSelectProps> = props => {
    const { selectedBilledTo, handleSelectedBilledToChange, required, errorMessage, onBlur, disabled, label = 'Material Bill To' } = props;

    const billedToTypeOptions = Object.values(BilledToType).filter((key => isNaN(Number(key))));

    return (
        <FormControl error={!!errorMessage} fullWidth required={required} disabled={disabled}>
            <FormLabel>{label}</FormLabel>
            <Select
                value={BilledToTypeToLabel[selectedBilledTo].label}
                onChange={(event) => {
                    handleSelectedBilledToChange?.(BilledToLabelToType[event.target.value as string]);
                }}
                onBlur={onBlur}
                disabled={disabled}
                sx={{ backgroundColor: 'white', borderRadius: '4px' }}
            >
                {billedToTypeOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                        {BilledToLabelToType[option] === BilledToType.TriAx ? 'Tri-Ax' : option}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>{errorMessage}</FormHelperText>
        </FormControl>
    )
}